import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { ATMobilityBenefitListItemExtension } from './at-mobility-benefit-list-item.extension';
import { ATMobilityBenefitMetadataExtension } from './at-mobility-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('at_mobility')
    .add(BenefitMetadataExtensionInterface, new ATMobilityBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new ATMobilityBenefitListItemExtension())
    .build(),
);
